import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  Paper,
} from '@material-ui/core';
import { 
  renderCheckbox,
  renderSelectField6,
} from '../../../form-global-components/components-form-components-for-react-final-form';
import { CURRENT_INSTANT_OFFENSE_LIST } from '../../../../actions/action-constants';
class FormFieldsTabClientDetailsTabsReferral extends Component {
  render() {    
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>
            
              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    locked={this.props.locked}
                    component={renderSelectField6}
                    id='referralsource' 
                    name='referralsource'
                    label='Referral Source'
                                                                                      // children={this.props.referralsourcesList}
                    dataArray={this.props.referralsourcesList.map(referralsource => ({
                      value: referralsource.id,
                      label: referralsource.description
                    }))}
                  />
{/* 
                  >
                    {this.props.referralsourcesList.map((referralsource, index) => {
                      return (
                        <option key={referralsource.id} value={referralsource.id} >{referralsource.description}</option>
                      )
                    }) }
                  </Field> 
*/}
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    locked={this.props.locked}
                    component={renderCheckbox}
                    id='priorcriminalbackground' 
                    name='priorcriminalbackground'
                    objName='priorcriminalbackground'
                    label='Prior Criminal Background?'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} >
                  <Field
                    locked={this.props.locked}
                    component={renderSelectField6}
                    id='currentinstantoffense' 
                    name='currentinstantoffense'
                    label='Current / Instant Offense'
                                                                                  // displayEmpty
                    dataArray={CURRENT_INSTANT_OFFENSE_LIST}
                  />
                                                                {/* 
                                                                                  >
                                                                                    <option value='1'>None</option>
                                                                                    <option value='2'>Violent</option>
                                                                                    <option value='3'>Drug Sales, Import, Manufacturer</option>
                                                                                    <option value='4'>Firearms</option>
                                                                                    <option value='5'>White Collar</option>
                                                                                    <option value='6'>Other utilitarian act or crime for personal or material gain</option>
                                                                                    <option value='7'>Other</option>
                                                                                    <option value='8'>Unknown</option>
                                                                                  </Field>
                                                                */}
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </Paper>  
        
      </div>
    );
  }
}
FormFieldsTabClientDetailsTabsReferral.propTypes = {
  locked: PropTypes.bool,
}
export default FormFieldsTabClientDetailsTabsReferral;